import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { InventoryContractType } from '../models/CompanyInventory.model';

@Injectable()
export class ContractTypesService {
    private endPoint = "/contract-types";

    constructor(private httpClient: HttpClient) { }

    async getAll(): Promise<InventoryContractType[]> {
        return await this.httpClient.get(this.endPoint)
    }

    async create(contractName: string): Promise<InventoryContractType> {
        return await this.httpClient.post(this.endPoint, {name: contractName})
    }
}



// WEBPACK FOOTER //
// ./src/app/services/contractTypes.service.ts